import { type FC, useEffect, useState } from 'react';
import classnames from 'classnames';

import { Spinner } from 'dibs-elements/exports/Spinner.tsx';

import styles from './styles/NftProfileImportCollectionViewSpinner.module.css';

export const NftProfileImportCollectionViewSpinner: FC<{ isOpen?: boolean }> = ({ isOpen }) => {
    const [isActive, setIsActive] = useState(!isOpen);
    useEffect(() => {
        // only render spinner if loading has taken over already taken 100ms
        let timeout: NodeJS.Timeout;
        if (isOpen) {
            timeout = setTimeout(() => {
                setIsActive(true);
            }, 100);
        }
        return () => clearTimeout(timeout);
    }, [isOpen]);

    useEffect(() => {
        // remove spinner 225ms after prop change to allow fade
        let timeout: NodeJS.Timeout;
        if (!isOpen && !isActive) {
            timeout = setTimeout(() => {
                setIsActive(false);
            }, 225);
        }
        return () => clearTimeout(timeout);
    }, [isActive, isOpen]);

    return isActive ? (
        <div className={classnames(styles.spinnerContainer, { [styles.fade]: !isOpen })}>
            <Spinner black containerClass={styles.spinner} />
        </div>
    ) : null;
};
